<template>
    <section class="btn-bar">
        <div class="container">
            <div class="paragraph" data-aos="fade-right">
                <h2>Recipe</h2>
                <p>
                    味全体に強さのある料理がジントニックにはベストマッチ。パンチのある辛さで料理を引き立てる、ガラムマサラのしっかり効いたオリジナルメニューを3つご紹介します。
                </p>
            </div>
            <div class="btn-wrap">
                <a href="" class="curry" v-scroll-to="'#curry'" data-aos="fade-up">
                    ビーフキーマカレー    
                </a>
                <a href="" class="maho" v-scroll-to="'#maho'" data-aos="fade-up">
                    四川麻婆豆腐    
                </a>
                <a href="" class="nabe" v-scroll-to="'#nabe'" data-aos="fade-up">
                    ガラムマサラチゲ鍋
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

.btn-bar{
    background: #fff;
    .btn-wrap{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: row wrap;
        margin-top: 72px;
        @media #{$maxL}{
            margin-top: 30px;
            flex-flow: column;
        }
            a{
                width: calc(33.333% - 20px);
                height: 64px;
                @extend %flex;
                font-family: $Default;
                font-size: 1.688em;
                color: #fff;
                @media #{$maxL}{
                    width: 100%;
                    height: 42px;
                    font-size: 1em;
                    margin-bottom: 20px;
                    max-width: 320px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                &.curry{
                    background: $curry;
                }
                &.maho{
                    background: $maho;
                }
                &.nabe{
                    background: $nabe;
                }
            }
    }

}
</style>